import React from 'react';
import { createRoot } from 'react-dom/client';
import AppRouter from './approuter';
import "datatables.net-responsive-dt";
import './assets/css/style.css';
import "./assets/css/dataTables.min.css";
import "./assets/css/dataTables.dataTables.min.css";
// import App from './App';

const domNode = document.getElementById('root');
const root = createRoot(domNode);

root.render(<AppRouter />);

if (module.hot) { // enables hot module replacement if plugin is installed
    module.hot.accept();
}
